// extracted by mini-css-extract-plugin
module.exports = {"btngrp":"style__btngrp__eSF8q","flex":"style__flex__EOOc7","lackPermissions":"style__lackPermissions__PtSTF","noIdPerm":"style__noIdPerm__I+g4d"};